<template>
  <v-app class="bgImage">
    <m-errorbox ref="errorBox"></m-errorbox>

    <navbar />

    <v-content class="secondary--text text--darken-2">
      <v-container fill-height>
        <v-row class="fill-height">
          <v-col cols="12">
            <v-row fill-height justify="center">
              <v-col xs="12" sm="12" md="8" lg="6">
                <v-card v-if="!linkContent" class="mt-10">
                  <v-card-title class="primary text-center pa-4 secondary--text text--darken-3">
                    <v-row justify="center">
                      <span class="text-uppercase text-center font-weight-light">
                        <span class="font-weight-medium">Generate Shareable Link</span>
                      </span>
                    </v-row>
                  </v-card-title>
                  <v-card-text class="mb-2 mt-4 text-center">
                    <p>
                      Use this form to create a link to share access to one of your Devices.
                      <b>
                        Anyone with a copy of the link can view this log up
                        until the expiration date.
                      </b> So be careful who you
                      share the link with, and avoid setting expiration dates
                      too far into the future.
                    </p>
                  </v-card-text>
                  <v-card-actions>
                    <v-row align="center" justify="center">
                      <m-form
                        v-slot="{model}"
                        :query="apiEndpoints.createLink"
                        :params="[this.$route.params.id]"
                        :rules="validationRules"
                        :modelSrc="formModel"
                        @success="onCreateLinkSuccess"
                        lazy-validation
                      >
                        <v-row align="center" justify="center">
                          <h3 class="secondary--text text--darken-3">Select Link Expiration Date</h3>
                        </v-row>
                        <v-row align="center" justify="center">
                          <v-col xs="12">
                            <m-datepicker :model="model" name="expires_at"></m-datepicker>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col xs="12">
                            <m-submit label="Generate" :model="model"></m-submit>
                            <v-btn
                              text
                              color="primary"
                              class="mb-3"
                              type="button"
                              @click="$router.back()"
                            >Cancel</v-btn>
                          </v-col>
                        </v-row>
                      </m-form>
                    </v-row>
                  </v-card-actions>
                </v-card>
                <v-card class="mt-10" v-else>
                  <v-card-title class="primary text-center pa-4 secondary--text text--darken-3">
                    <v-row justify="center">
                      <span class="text-uppercase text-center font-weight-light">
                        <span class="font-weight-medium">Link Generated</span>
                      </span>
                    </v-row>
                  </v-card-title>
                  <v-card-text class="mb-2 mt-4 text-center">
                    <p>
                      <b>
                        Anyone with a copy of this link can view the linked log up
                        until the expiration date.
                      </b> So be careful who you
                      share the link with!
                      <br />
                      <br />Here is your Link:
                      <br />
                      <a class="title" :href="linkContent">{{linkContent}}</a>
                      <br />Select and copy it into an email or document for distribution.
                    </p>
                  </v-card-text>
                  <v-card-actions>
                    <v-row align="center" justify="center">
                      <v-btn
                        color="primary"
                        class="mb-3 secondary--text text--darken-3"
                        @click="$router.back()"
                      >Done</v-btn>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>


<script>
import apiEndpoints from "../mixins/api-endpoints";

export default {
  mixins: [apiEndpoints],
  data() {
    return {
      linkContent: "",
      validationRules: {
        expires_at: model => [
          v => !!v || "Expiration date is required",
          v => (v && v >= (new Date().getTime() / 1000)) || "Expiration date must be in the future",
          v => {
            let today = new Date();
            let year = today.getFullYear();
            let month = today.getMonth();
            let day = today.getDate();
            let maxDate = new Date(year+1, month, day).getTime() / 1000;
            return (v && v <= maxDate) || "Expiration date must within one year of todays date";
          },
        ]
      },
      formModel:{},
    };
  },
  methods: {
    showError(message) {
      this.$refs.errorBox.showError(message);
    },
    onCreateLinkSuccess(body) {
      console.log("CreateSuccess!!!!");
      console.log(body);
      this.linkContent = window.apiBaseUrl + "link/" + body.data.token;
    },
    onFormCancel() {}
  },
  computed: {}
};
</script>
